import { animate, state, style, transition, trigger } from "@angular/animations";
import { Component, ElementRef, Injector, Type, ViewChild } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import {
  BenchmarkDataPrimaryLookupService,
  BfxBlotterAction,
  BfxBlotterOrdersContextMenuItem,
  BmarkFixingData,
  HedgeOrderDataPrimaryLookupService,
  SpotRiskModel,
} from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import {
  BfxHedgeOrderMonitorComponent,
  BfxHedgeOrderMonitorComponentData,
} from "app/bfx-hedge-order-monitor/bfx-hedge-order-monitor.component";
import { BfxHedgeOrderMonitorSpotRiskService } from "app/bfx-hedge-order-monitor/services/bfx-hedge-order-monitor-spot-risk.service";
import { BfxBaseBlotterContextMenu } from "../../../bfx-base-blotter/bfx-base-blotter-contextmenu";
import { NativeDesktopSupport } from "../../../bfx-native-desktop/native-desktop-support";
import {
  BmarkSpotRiskTraderGroupsMenuComponent,
  SelectedTraderGroupEvent,
} from "../spot-risk/bmark-spot-risk-tradergroups-menu.component";
import { BmarkHedgeOrdersBlotterComponent } from "./bmark-hedge-orders-blotter.component";
import { BmarkHedgeOrdersContextMenuService } from "./services/bmark-hedge-orders-context-menu.service";
import { SpotRiskPair } from "shared/cubiq-services/lookup/model/impl/bmrisk/SpotRiskModel";

@Component({
  selector: "bmark-hedge-orders-context-menu",
  templateUrl: "./html/bmark-hedge-orders-context-menu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BmarkHedgeOrdersContextMenuComponent extends BfxBaseBlotterContextMenu<CubiqTS.OrderDataImpl> {
  @ViewChild("tgMenu", {
    read: BmarkSpotRiskTraderGroupsMenuComponent,
    static: true,
  })
  private traderGroupMenuComponent: BmarkSpotRiskTraderGroupsMenuComponent;

  constructor(
    injector: Injector,
    protected spotRiskDataService: BfxHedgeOrderMonitorSpotRiskService,
    lookupService: HedgeOrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BmarkHedgeOrdersContextMenuService> {
    return BmarkHedgeOrdersContextMenuService;
  }

  /*     ngAfterViewInit(): void {
            if (NativeDesktopSupport.isNativeDesktopContainer() && this.parentElement == null) {
                this.parentElement = this.elementRef.nativeElement.parentElement;
                this.position.x = this.position.y = 0;
                logger.out.info(`KKND: BfxBmarkHedgeOrdersContextMenuComponent.ngAfterViewInit(): Window ${this._window} | id: ${this.id}`);// 
              /*   if (this._window != null) {
                    this._window.getNativeWindow().document.body.childNodes.forEach(c => c.parentNode.removeChild(c));
                    this._window.getNativeWindow().document.body.appendChild(this.elementRef.nativeElement);
                } else { *
                if(this._window == null){
                    this.initialize();
                }
            }
        } */

  public showMenuAt(x: number, y: number): void {
    if (this.traderGroupMenuComponent) {
      this.traderGroupMenuComponent.hideMenu();
    }
    super.showMenuAt(x, y);
  }

  public hideMenu(): boolean {
    if (this.traderGroupMenuComponent) {
      this.traderGroupMenuComponent.hideMenu();
    }
    return super.hideMenu();
  }

  public selectedMenuItem(item: BfxBlotterOrdersContextMenuItem, event?: any) {
    //logger.out.info(`KKND: selectedMenuItem(): CLIENT ORDERS BINGO `);//| id: ${this.id}
    if (this.isItemEnabled(item)) {
      (this.menuService as BmarkHedgeOrdersContextMenuService).fireActionEvent(
        item.actionId,
        this.currentLadderBlotter,
        null,
        null,
        item.state,
        null,
        null,
        event,
      );
      if (item.clearSelection) {
        this.currentLadderBlotter?.gridOptions?.api?.deselectAll();
        this.currentLadderBlotter?.onSelectionChanged([]);
      }
      this.hideMenu();
    }
  }

  public onTraderGroupSelected(data: SelectedTraderGroupEvent): void {
    const traderGroupId: string =
      data !== null && typeof data === "object" && CubiqTS.Long.isLong(data.traderGroupId)
        ? data.traderGroupId.toString()
        : "";

    logger.out.info(
      `${this.constructor.name}.onTraderGroupSelected() traderGroupId: ${traderGroupId}`,
    );

    if (this.currentLadderBlotter instanceof BmarkHedgeOrdersBlotterComponent) {
      let hedgeBlotter: BmarkHedgeOrdersBlotterComponent = this
        .currentLadderBlotter as BmarkHedgeOrdersBlotterComponent;
      let pairList: string[] = [
        ...new Set(
          hedgeBlotter.gridOptions.api
            .getSelectedRows()
            .map((row: CubiqTS.OrderDataImpl) => row.baseCode + row.nonBaseCode),
        ),
      ];
      let hedgeOrderMonitor: BfxHedgeOrderMonitorComponent =
        this.currentLadderBlotter.parentComponent;
      let fixing: BmarkFixingData = hedgeOrderMonitor.fixingData;
      this.spotRiskDataService
        .getPositionTotals(
          fixing.id,
          pairList,
          data.menuIdentifier == BfxBlotterAction[BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO_DEALT],
        )
        .then((results: { pair: string; total: CubiqTS.BigNumber }[]) => {
          let hedgeOrderMonitorData: BfxHedgeOrderMonitorComponentData =
            new BfxHedgeOrderMonitorComponentData();
          hedgeOrderMonitorData.fixingData = fixing;
          hedgeOrderMonitorData.traderGroupId = data.traderGroupId;
          hedgeOrderMonitorData.positions = results.map(
            (result: any) =>
              new SpotRiskPair(
                result.pair.substring(0, 3),
                result.pair.substring(3),
                null,
                result.total,
              ),
          );
          hedgeOrderMonitor.proposeOrderRequests(hedgeOrderMonitorData);
        });
    }
  }

  public showTraderGroups(event, contMenuRef: Element, menuItem): void {
    if (
      (menuItem.actionId == BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO ||
        menuItem.actionId == BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO_DEALT) &&
      event != null &&
      event.target != null &&
      event.target.getBoundingClientRect != null &&
      event.target.textContent.indexOf("Send Residual") == 0
    ) {
      let menuBoundingClientRef: any = event.target.getBoundingClientRect();
      this.traderGroupMenuComponent.menuIdentifier = BfxBlotterAction[menuItem.actionId];
      this.traderGroupMenuComponent.showMenuAt(menuBoundingClientRef, this);
    } else {
      this.hideTraderGroups(menuItem);
    }
  }

  public hideTraderGroups(menuItem): void {
    if (
      menuItem.actionId !== BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO ||
      menuItem.actionId !== BfxBlotterAction.ACTION_SPOT_RISK_SEND_TO_DEALT
    ) {
      this.traderGroupMenuComponent.hideMenu();
    }
  }
}
